import {createSelector} from 'reselect';
import {AppState} from '../../../index';

export const LoginStepSelector = () =>
  createSelector(
    (state: AppState) => state.runtime.loginStep.value,
    (item) => item,
  );
